import React, { FunctionComponent } from 'react';
import { useSelector } from "react-redux";
import { CommercialOperations } from "@/models/scope/productSheet/CommercialOperations";
import { ShippingMethodItem } from '@/models/scope/shipping/ShippingMethodItem';
import { AvailabilityByShop } from '@/models/scope/availability/AvailabilityByShop';
import { DetailedAvailability } from '@/models/scope/availability/DetailedAvailability';
import { RootState } from "@/models/appState/RootState";
import { maxPictoNumberIsDisplayed, removeLastCommertialSteaker } from "@/animations/responsive/productSheetPage";
import Utils from "@/libs/Utils";

interface Props {
    commercialOperations: CommercialOperations[];
}

const extractShippingMethods = (
    dataShippingMethods: AvailabilityByShop | DetailedAvailability | Record<string, never>
): { homeMethods: ShippingMethodItem[], relayMethods: ShippingMethodItem[] } => {
    let homeMethods: ShippingMethodItem[] = [];
    let relayMethods: ShippingMethodItem[] = [];

    if ('shippingToCustomerMethods' in dataShippingMethods) {
        homeMethods = dataShippingMethods.shippingToCustomerMethods?.items || [];
        const highlightMethods = dataShippingMethods.hightlightShippingMethods?.items || [];
        homeMethods = homeMethods.concat(highlightMethods);
    }

    if ('relayPointShippingMethods' in dataShippingMethods) {
        relayMethods = dataShippingMethods.relayPointShippingMethods?.items || [];
    }

    return { homeMethods, relayMethods };
};

const getFreeShippingText = (
    homeMethods: ShippingMethodItem[],
    relayMethods: ShippingMethodItem[],
    maxDisplayedPicto: number
): string | null => {
    let homeShipping = false;
    let relayPointShipping = false;
    homeMethods.forEach(method => {
        if (parseInt(String(method.cost)) === 0 ) {
            if (maxPictoNumberIsDisplayed(maxDisplayedPicto)) {
                removeLastCommertialSteaker(); 
            }
            homeShipping = true;
        }
    });

    relayMethods.forEach(method => {
        if (parseInt(String(method.cost)) === 0 ) {
            if (maxPictoNumberIsDisplayed(maxDisplayedPicto)) {
                removeLastCommertialSteaker();
            }
            relayPointShipping = true;
        }
    });

    if (homeShipping && relayPointShipping) {
        return "LIVRAISON OFFERTE À DOMICILE ET EN POINT DE RETRAIT";
    } else if (relayPointShipping) {
        return "LIVRAISON EN POINT DE RETRAIT OFFERTE";
    } else if (homeShipping) {
        return "LIVRAISON OFFERTE À DOMICILE";
    }
    return null;
};

export const FreeShippingPicto: FunctionComponent<Props> = ({ commercialOperations }) => {
    const availabilityByShops = useSelector((state: RootState) => state.availability.availabilityByShops);
    const detailedAvailablity = useSelector((state: RootState) => state.availability.detailedAvailablity);
    const maxDisplayedPicto = commercialOperations?.length > 0
        ? Utils.getMaxDisplayedCommercialOperationsOfTypeCommercial(commercialOperations)
        : 4;

    const dataShippingMethods = availabilityByShops && availabilityByShops?.length > 0
        ? availabilityByShops[0]
        : detailedAvailablity
            ? detailedAvailablity
            : null;

    if (!dataShippingMethods) {
        return null;
    }

    const { homeMethods, relayMethods } = extractShippingMethods(dataShippingMethods);
    const pictoShippingText = getFreeShippingText(homeMethods, relayMethods, maxDisplayedPicto);

    return pictoShippingText ? (
        <div className='free-shipping-picto'>
            <p>{pictoShippingText}</p>
        </div>
    ) : null;
};
